let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3WEpk")).then(() => parcelRequire('4mTJs'));